import * as types from '../actions/ActionTypes';
import initialState from './InitialState';

export default function paymentJournalsReducer(
    state: any = initialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.GET_PAYMENT_LOG_LIST:
            return {
                ...state,
                legalEntities: action.result.legalEntities
            };

        case types.GET_PAYMENT_LOG:
            return {
                ...state,
                paymentJournal: action.result.paymentJournal
            };

        case types.CREATE_PAYMENT_LOG:
            return {
                ...state,
                legalEntities: state.legalEntities.map((entity) => {
                    if (
                        entity.id === action.result.legalEntityId &&
                        entity.site === action.result.site
                    ) {
                        return {
                            ...entity,
                            paymentJournals: [
                                action.result.paymentJournal,
                                ...entity.paymentJournals
                            ],
                            numberOfNewPayments: action.result.numberOfNewPayments
                        };
                    } else {
                        return entity;
                    }
                })
            };

        default:
            return state;
    }
}
